/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getRelativeDateValue } from './LocalizedDate';
import FileModel from '../../models/FileModel';

function getFileSizeMessageKey(fileSizeUnit) {
  switch (fileSizeUnit) {
    case 'kB':
      return 'ui-data.file-size.kilobytes.text';
    case 'MB':
      return 'ui-data.file-size.megabytes.text';
    case 'GB':
      return 'ui-data.file-size.gigabytes.text';
    default:
      return 'ui-data.file-size.bytes.text';
  }
}

const FileSize = (props) => (
  <FormattedMessage
    id={getFileSizeMessageKey(props.fileSizeData.unit)}
    values={{ string1: props.fileSizeData.size }}
  />
);
FileSize.propTypes = {
  fileSizeData: PropTypes.shape({
    size: PropTypes.number,
    unit: PropTypes.oneOf(['b', 'kB', 'MB', 'GB']),
  }),
};

const FileTypeName = ({ file }) => (
  <FormattedMessage
    id={`list.file-types.${file.getFileTypeCategory()}.name`}
    values={{ digit1: 1 }}
  />
);
FileTypeName.propTypes = {
  file: PropTypes.object,
};

const LocalizedFileSummaryText = (props) => {
  const fileSizeData = props.file.fileSizeData();

  const fileSizeText = props.intl.formatMessage(
    {
      id: getFileSizeMessageKey(fileSizeData.unit),
    }, {
      string1: fileSizeData.size,
    }
  );

  const categoryId = props.file.getCategoryMessageKey();
  const categoryText = props.file.hasCategory() ? props.intl.formatMessage({ id: categoryId }) : '';
  const observed = props.file.getObservedDate();
  return (
    <span>
      {
        _.compact([categoryText, fileSizeText, getRelativeDateValue(props.intl, observed.date, observed.precision, 'medium', false)]).join(' — ')
      }
    </span>
  );
};
LocalizedFileSummaryText.propTypes = {
  intl: PropTypes.object,
  file: PropTypes.instanceOf(FileModel).isRequired,
};

const FileSummaryText = injectIntl(LocalizedFileSummaryText);

export {
  FileSize,
  FileSummaryText,
  FileTypeName,
};
